module.exports = __webpack_public_path__ + "static/media/brochure.25d5368b.png";